<template>
  <div>
    <div class="shade-section user-profile">
      <div class="cover-block user-cover-block">
        <div class="profile-header">
          <div class="avatar-hover">
            <template v-if="avatar">
              <template v-if="avatar.includes('https:')">
                <img
                  :src="`${avatar}`"
                  class="avatar s100"
                  alt="avatar"
                >
              </template>
              <template v-else>
                <img
                  :src="`${$base_api}/${avatar}`"
                  class="avatar s100"
                  alt="avatar"
                >
              </template>
            </template>
            <template v-else>
              <img
                src="../../../public/img/woman-call.png"
                class="avatar s100"
                alt="avatar"
              >
            </template>
          </div>
          <div class="user-info">
            <div
              class="cover-title"
              v-if="borrower"
            >
              {{ borrower.name }} {{ borrower.last_name }}
            </div>
            <div
              class="cover-title"
              v-else-if="user"
            >
              {{ user.name }}
            </div>
            <div class="cover-score mb8">
              <!--               <span v-if="score"-->
              <!--                     class="label-score"-->
              <!--                     data-toggle="tooltip" data-placement="top" title="The profile score">-->
              <!--                 <img :src="'/img/icons/medal.svg'" alt="score icon" class="score-icon">-->
              <!--                 {{$t('label.score')}} {{parseFloat(score.score).toFixed(2)}}-->
              <!--               </span>-->
              <span v-if="borrower">
                <template v-if="borrower.membership">
                  <template v-if="membership.icon">
                    <img
                      :src="$base_api + '/' + membership.icon"
                      alt="score icon"
                      class="membership-icon"
                    >
                  </template>
                  <template v-else>
                    <img
                      :src="'/img/icons/star.svg'"
                      alt="score icon"
                      class="membership-icon"
                    >
                  </template>
                  <span
                    class="no-margin"
                    :style="`color: ${membership.color}`"
                  >
                    {{ $i18n.locale === 'km' ? membership.name_km : membership.name_en }}
                  </span>
                </template>
                <template v-else>
                  <img
                    :src="'/img/icons/star.svg'"
                    alt="score icon"
                    class="membership-icon"
                  >
                  {{ $i18n.locale === 'km' ? 'សមាជិក' : 'Member' }}
                </template>
              </span>
            </div>
            <div
              class="cover-status mb8"
              v-if="user"
            >
              <span>
                {{ $t('label.memberSince') }}
                {{ $moment(user.created_at).locale($i18n.locale).format('ll') }}
              </span>
            </div>
            <div
              class="cover-desc"
              v-if="borrower"
            >
              <div class="location mb8">
                <img
                  src="../../../public/img/icons/marker.svg"
                  alt="marker icon"
                  class="inline-icon"
                  style="width: 16px"
                >
                <label class="mt-1 address">
                  <span v-if="borrower.commune">{{ borrower.commune }}</span>
                  <span v-if="borrower.district">{{ borrower.district }}</span>
                  <span v-if="borrower.province">{{ borrower.province }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div
          class="scrolling-tabs-container"
          v-if="borrower"
        >
          <div class="fade-left">
            <i class="fas fa-angle-left" />
          </div>
          <div class="fade-right">
            <i class="fas fa-angle-right" />
          </div>
          <ul
            class="nav nav-links scrolling-tabs"
            id="pills-tab"
            role="tablist"
          >
            <li class="nav-item">
              <a
                class="nav-link"
                :class="activeTabs === 'profile'? 'active' : ''"
                id="pills-profile-tab"
                data-toggle="pill"
                href="#pills-profile"
                role="tab"
                aria-controls="pills-profile"
                aria-selected="false"
              >
                {{ $t('label.profile') }}
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                :class="activeTabs === 'history'? 'active' : ''"
                id="pills-history-tab"
                data-toggle="pill"
                href="#pills-history"
                role="tab"
                aria-controls="pills-history"
                aria-selected="false"
              >
                {{ $t('label.loanHistory') }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <template v-if="fetching">
      <div class="fetching">
        <div class="gooey">
          <span class="dot" />
          <div class="dots">
            <span />
            <span />
            <span />
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <template v-if="borrower">
        <div class="container">
          <template v-if="is_loan_pending">
            <div style="padding-top: 20px">
              <div
                class="alert alert-cash-hero"
                role="alert"
                style="margin: 0"
              >
                {{ loan ? $moment(loan.created_at).format('DD/MM/YYYY HH:mm:ss A') : '' }}:
                {{ $t('label.hasLoanPanding') }}
                <button
                  type="button"
                  class="close close-cash-hero"
                  data-dismiss="alert"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
          </template>
          <div
            class="tab-content"
            id="pills-tabContent"
          >
            <div
              class="tab-pane fade"
              id="pills-profile"
              :class="activeTabs === 'profile'? 'show active' : ''"
              role="tabpanel"
              aria-labelledby="pills-profile-tab"
            >
              <div class="col aline-button no-padding">
                <button-borrow />
                <button
                  class="btn btn-outline-secondary"
                  type="button"
                  data-toggle="tooltip"
                  data-placement="top"
                  :title="$t('label.changePassword')"
                  @click="resetPassword"
                >
                  <i class="fas fa-lock" /> {{ $t('label.changePassword') }}
                </button>
              </div>
              <div class="message-content pt64">
                <!--                <div class="float-right btn-setting">-->
                <!--                  <button class="btn btn-outline-info btn-sm"-->
                <!--                          type="button"-->
                <!--                          data-toggle="tooltip"-->
                <!--                          data-placement="top"-->
                <!--                          :title="$t('label.editProfile')"-->
                <!--                          @click="editProfile('personal')">-->
                <!--                    <i class="fas fa-edit"></i> {{$t('global.btn.edit')}}-->
                <!--                  </button>-->
                <!--                </div>-->
                <div class="personal-info mb16">
                  <div class="row">
                    <div class="col-md-12">
                      <h1 class="block-title">
                        {{ $t('form.borrow.label.personal_info') }}
                      </h1>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-6 col-sm-3 col-form-label">{{ $t('form.borrow.id_number') }} :</label>
                    <label class="col-6 col-sm-9 col-form-label">{{ borrower.national_id_number || 'N/A' }}</label>
                  </div>
                  <div class="form-group row">
                    <label class="col-6 col-sm-3 col-form-label">{{ $t('form.borrow.dob') }} :</label>
                    <label class="col-6 col-sm-9 col-form-label">
                      {{ $moment(borrower.date_of_birth).format('ll') }}
                    </label>
                  </div>
                  <div
                    class="form-group row"
                    v-if="borrower.gender"
                  >
                    <label class="col-6 col-sm-3 col-form-label">{{ $t('form.borrow.gender.label') }} :</label>
                    <label class="col-6 col-sm-9 col-form-label">
                      {{ borrower.gender.trim() === "Male" ? 'Male' : 'Female' }}
                    </label>
                  </div>
                  <div class="form-group row">
                    <label class="col-6 col-sm-3 col-form-label">{{ $t('form.borrow.phone') }} :</label>
                    <label class="col-6 col-sm-9 col-form-label">
                      {{ borrower.phone }}
                    </label>
                  </div>
                  <div class="form-group row">
                    <label class="col-6 col-sm-3 col-form-label">{{ $t('form.borrow.email') }} :</label>
                    <label class="col-6 col-sm-9 col-form-label">
                      {{ borrower.email }}
                    </label>
                  </div>
                  <div class="form-group row">
                    <label class="col-6 col-sm-3 col-form-label">{{ $t('form.borrow.maritalStatus.label') }} :</label>
                    <label class="col-6 col-sm-9 col-form-label">
                      {{ borrower.marital_status || 'N/A' }}
                    </label>
                  </div>
                  <div class="form-group row">
                    <label class="col-6 col-sm-3 col-form-label">{{ $t('form.borrow.address') }} :</label>
                    <label class="col-6 col-sm-9 col-form-label">
                      <template
                        v-if="borrower.home_number || borrower.street_number ||
                          borrower.address || borrower.commune || borrower.district || borrower.province"
                      >
                        <template v-if="borrower.home_number">
                          <label>#{{ borrower.home_number }},</label>
                        </template>
                        <template v-if="borrower.street_number">
                          <label> St {{ borrower.street_number }},</label><br>
                        </template>
                        <template v-if="borrower.commune">
                          <label>{{ $t('form.borrow.commune') }}: {{ borrower.commune }}</label><br>
                        </template>
                        <template v-if="borrower.district">
                          <label>{{ $t('form.borrow.district') }}: {{ borrower.district }}</label><br>
                        </template>
                        <template v-if="borrower.province">
                          <label> {{ $t("form.borrow.province") }}: {{ borrower.province }}</label>
                        </template>
                      </template>
                      <template v-else>
                        <span v-if="borrower.address">{{ borrower.address }}</span>
                        <span v-else>N/A</span>
                      </template>
                    </label>
                  </div>
                </div>
                <hr>
                <!--                <div class="float-right btn-setting">-->
                <!--                  <button class="btn btn-outline-info btn-sm"-->
                <!--                          type="button"-->
                <!--                          data-toggle="tooltip"-->
                <!--                          data-placement="top"-->
                <!--                          :title="$t('label.editEducation')"-->
                <!--                          @click="editProfile('education')">-->
                <!--                    <i class="fas fa-edit"></i> {{$t('global.btn.edit')}}-->
                <!--                  </button>-->
                <!--                </div>-->
                <div class="education mb16">
                  <div class="row">
                    <div class="col-md-12">
                      <h1 class="block-title">
                        {{ $t('label.education_info') }}
                      </h1>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-6 col-sm-3 col-form-label">{{ $t('label.educationLevel') }} :</label>
                    <label
                      class="col-6 col-sm-9 col-form-label"
                      v-if="borrower.borrow_education || borrower.graduate_year"
                    >
                      {{ borrower.borrow_education.name || 'N/A' }}
                      <template v-if="borrower.borrow_education_id && borrower.borrow_education_id !== 1">
                        <span
                          class="label-span"
                          v-if="borrower.borrow_education.name"
                        >
                          ({{ $t('label.graduateYear') }} {{ borrower.graduate_year || 'N/A' }})
                        </span>
                      </template>
                    </label>
                    <label
                      class="col-6 col-sm-9 col-form-label"
                      v-else
                    >N/A</label>
                  </div>
                  <template v-if="borrower.borrow_education_id && borrower.borrow_education_id !== 1">
                    <div class="form-group row">
                      <label class="col-6 col-sm-3 col-form-label">{{ $t('label.schoolName') }} :</label>
                      <label class="col-6 col-sm-9 col-form-label">{{ borrower.school_name || 'N/A' }}</label>
                    </div>
                    <template v-if="borrower.borrow_education_id && borrower.borrow_education_id !== 2">
                      <div class="form-group row">
                        <label class="col-6 col-sm-3 col-form-label">{{ $t('label.major') }} :</label>
                        <label class="col-6 col-sm-9 col-form-label">{{ borrower.study_major || 'N/A' }}</label>
                      </div>
                    </template>
                  </template>
                </div>
                <hr>
                <!--                <div class="float-right btn-setting">-->
                <!--                  <button class="btn btn-outline-info btn-sm"-->
                <!--                          type="button"-->
                <!--                          data-toggle="tooltip"-->
                <!--                          data-placement="top"-->
                <!--                          :title="$t('label.editEmployment')"-->
                <!--                          @click="editProfile('employment')">-->
                <!--                    <i class="fas fa-edit"></i> {{$t('global.btn.edit')}}-->
                <!--                  </button>-->
                <!--                </div>-->
                <div class="employment mb16">
                  <div class="row">
                    <div class="col-md-12">
                      <h1 class="block-title">
                        {{ $t('form.borrow.label.employment_info') }}
                      </h1>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-6 col-sm-3 col-form-label">{{ $t('form.borrow.name_of_company') }} :</label>
                    <label class="col-6 col-sm-9 col-form-label">
                      {{ borrower.company_name || 'N/A' }}
                      <span
                        class="label-span"
                        v-if="borrower.company_type"
                      >({{ borrower.company_type }})</span>
                    </label>
                  </div>
                  <div class="form-group row">
                    <label class="col-6 col-sm-3 col-form-label">{{ $t('form.borrow.occupation') }} :</label>
                    <label class="col-6 col-sm-9 col-form-label">{{ borrower.occupation || 'N/A' }}</label>
                  </div>
                  <div class="form-group row">
                    <label class="col-6 col-sm-3 col-form-label">{{ $t('form.borrow.monthly_income') }} :</label>
                    <label class="col-6 col-sm-9 col-form-label">{{ borrower.gross_monthly_income || 'N/A' }}</label>
                  </div>
                </div>
                <hr>
                <!--                <div class="float-right btn-setting">-->
                <!--                  <button class="btn btn-outline-info btn-sm"-->
                <!--                          type="button"-->
                <!--                          data-toggle="tooltip"-->
                <!--                          data-placement="top"-->
                <!--                          :title="$t('label.editRelative')"-->
                <!--                          @click="editProfile('relative')">-->
                <!--                    <i class="fas fa-edit"></i> {{$t('global.btn.edit')}}-->
                <!--                  </button>-->
                <!--                </div>-->
                <div class="contact-person mb16">
                  <div class="row">
                    <div class="col-md-12">
                      <h1 class="block-title">
                        {{ $t('form.borrow.label.reference') }}
                      </h1>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-6 col-sm-3 col-form-label no-pb">{{ $t('form.borrow.company_contact_name') }}
                      :</label>
                    <label class="col-6 col-sm-9 col-form-label no-pb">
                      {{ borrower.company_contact_name || 'N/A' }}
                      <!--                      <span class="label-span" v-if="borrower.company_contact_name">(Coworker)</span>-->
                    </label>
                    <label class="col-6 col-sm-3 col-form-label no-pt">{{ $t('form.borrow.telephone') }} :</label>
                    <label class="col-6 col-sm-9 col-form-label no-pt">
                      {{ borrower.company_contact_phone || 'N/A' }}
                    </label>
                  </div>
                  <div class="form-group row">
                    <label class="col-6 col-sm-3 col-form-label no-pb">{{ $t('form.borrow.relative.name') }} :</label>
                    <label class="col-6 col-sm-9 col-form-label no-pb">
                      {{ borrower.relative_name || 'N/A' }}
                      <span
                        class="label-span"
                        v-if="borrower.relative_type"
                      >({{ borrower.relative_type }})</span>
                    </label>
                    <label class="col-6 col-sm-3 col-form-label no-pt">{{ $t('form.borrow.relative.contact') }}
                      :</label>
                    <label class="col-6 col-sm-9 col-form-label no-pt">
                      {{ borrower.relative_contact_phone || 'N/A' }}
                    </label>
                  </div>
                </div>
                <hr>
                <!--                <div class="float-right btn-setting">-->
                <!--                  <button class="btn btn-outline-info btn-sm"-->
                <!--                          type="button"-->
                <!--                          data-toggle="tooltip"-->
                <!--                          data-placement="top"-->
                <!--                          :title="$t('label.editBank')"-->
                <!--                          @click="editProfile('bank')">-->
                <!--                    <i class="fas fa-edit"></i> {{$t('global.btn.edit')}}-->
                <!--                  </button>-->
                <!--                </div>-->
                <div class="contact-person mb16">
                  <div class="row">
                    <div class="col-md-12">
                      <h1 class="block-title">
                        {{ $t('form.borrow.label.bank_info') }}
                      </h1>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-6 col-sm-3 col-form-label">{{ $t('form.borrow.bank_name') }} :</label>
                    <label class="col-6 col-sm-9 col-form-label">{{ borrower.bank_name || 'N/A' }}</label>
                  </div>
                  <div class="form-group row">
                    <label class="col-6 col-sm-3 col-form-label">{{ $t('form.borrow.account_name') }} :</label>
                    <label class="col-6 col-sm-9 col-form-label">{{ borrower.bank_account_number || 'N/A' }}</label>
                  </div>
                </div>
                <hr>
                <!--                <div class="float-right btn-setting">-->
                <!--                  <button class="btn btn-outline-info btn-sm"-->
                <!--                          type="button"-->
                <!--                          data-toggle="tooltip"-->
                <!--                          data-placement="top"-->
                <!--                          :title="$t('label.editSocial')"-->
                <!--                          @click="editProfile('social')">-->
                <!--                    <i class="fas fa-edit"></i> {{$t('global.btn.edit')}}-->
                <!--                  </button>-->
                <!--                </div>-->
                <div class="contact-person mb16">
                  <div class="row">
                    <div class="col-md-12">
                      <h1 class="block-title">
                        {{ $t('label.socialMedia') }}
                      </h1>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-6 col-sm-3 col-form-label no-pb">{{ $t('form.borrow.facebook_name') }} :</label>
                    <label class="col-6 col-sm-9 col-form-label no-pb">{{ borrower.facebook_name || 'N/A' }}</label>
                  </div>
                  <div class="form-group row">
                    <label class="col-6 col-sm-3 col-form-label no-pt">{{ $t('form.borrow.facebook_link') }} :</label>
                    <label class="col-6 col-sm-9 col-form-label no-pt">
                      <template v-if="borrower.facebook_link">
                        <a
                          :href="borrower.facebook_link"
                          target="_blank"
                        >{{ $t('label.facebook_link') }}</a>
                      </template>
                      <template v-else>
                        N/A
                      </template>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <!--            Loan History-->
            <div
              class="tab-pane fade"
              id="pills-history"
              :class="activeTabs === 'history'? 'show active' : ''"
              role="tabpanel"
              aria-labelledby="pills-history-tab"
            >
              <loan-transaction />
            </div>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import LoanTransaction from './components/LoanTransaction'
import ButtonBorrow from '../../components/ButtonBorrow'

export default {
  name: 'Profile',
  metaInfo: {
    title: 'User profile',
    titleTemplate: '%s | Cash Hero',
    meta: [
      { charset: 'utf-8' },
      { name: 'description', content: 'User profile' }
    ]
  },
  computed: {
    avatar () {
      return this.$store.state.borrow.borrower_photo
    },
    is_loan_pending () {
      return this.$store.state.has_pending_loan
    }
  },
  props: {
    // eslint-disable-next-line vue/require-prop-types
    activeTabs: {
      default: 'profile'
    }
  },
  components: { LoanTransaction, ButtonBorrow },
  data () {
    return {
      borrower: null,
      user: null,
      membership: null,
      has_pending_loan: false,
      borrow: {
        amount: 50,
        duration: 5
      },
      fetching: true,
      showMessagePending: true,
      score: null,
      loan: null
    }
  },
  methods: {
    applyNow (loan_type) {
      this.user.loanType = loan_type
      this.$store.dispatch('setAmountAndDuration', this.borrow)
      this.$store.dispatch('setDataBorrower', this.user)
      this.$router.push({ name: 'borrow-form', params: { formType: 'profile' } })
    },
    getBorrowerInfo () {
      this.$axios.post(this.$base_api + '/api/v1/frontend/borrow/get-borrow-info')
        .then((response) => {
          if (response.data.code === 1) {
            this.borrower = response.data.data
            if (this.borrower.phone) {
              this.borrower.phone = this.borrower.phone.replace('855', '0')
            }
            if (this.borrower.membership_id) {
              this.membership = this.borrower.membership
            }
            if (this.borrower && this.borrower.user) {
              this.$store.dispatch('setAvatar', this.borrower.user.avatar)
            }
            localStorage.setItem('borrower', JSON.stringify(this.borrower))
            this.checkUserHasLoadpanding()
          }
        }).catch((error) => {
          this.responseError(error.response)
        }).finally(() => {
          this.fetching = false
        })
    },
    checkUserHasLoadpanding () {
      this.$axios.post(this.$base_api + '/api/v1/frontend/borrow/check-account-has-loan-pending')
        .then((response) => {
          if (response.data.code === 1) {
            this.has_pending_loan = response.data.data.has_pending_loan
            this.loan = response.data.data.loan
            this.$store.dispatch('checkUserHasPendingLoan', this.has_pending_loan)
          }
        }).catch((error) => {
          this.responseError(error.response)
        })
    },
    resetPassword () {
      sessionStorage.setItem('fromPage', 'reset-password')
      this.$router.push({ name: 'reset-password', params: { fromPage: sessionStorage.getItem('fromPage') } })
    }
  },
  mounted () {
    if (!localStorage.getItem('token')) {
      // change redirect to home page
      this.$router.push({ name: this.$default_page })
    } else {
      if (!localStorage.hasOwnProperty('user')) {
        this.getUserInfo()
      } else {
        this.user = JSON.parse(localStorage.getItem('user'))
      }
      this.getBorrowerInfo()
    }
  }
}
</script>

<style scoped>
@import "../../assets/styles/profile.css";
@import "../../assets/styles/fecthing.css";

.aline-button {
  text-align: right;
  margin-top: 20px;
}

.no-margin {
  margin: 0 !important;
}

.membership-icon {
  vertical-align: top;
  width: 20px;
}

hr {
  margin: 1.5rem 0 !important;
}

.address span:after {
  content: ', ';
}

.address span:last-child:after {
  content: '';
}
</style>
